import ModuleWrapper from 'shared-lib/containers/Module';

const CurrencyList  = () => import(/* webpackChunkName: "currency-list" */ '@/views/currencies/CurrencyList');
const meta = (data = {}) => ({
    permissionsModuleName: 'config',
    auth: true,
    ...data,
});

export default [{
    path: 'currencies',
    component: ModuleWrapper,
    meta: meta({
        title: 'Currencies',
    }),
    children: [
        {
            path: '',
            name: 'Currency Management',
            component: CurrencyList,
            meta: meta(),
        },
    ],
}];
